import { equalPrimitiveArrays as e } from "./array.js";
//#region src/utils/object.ts
var t = (t, n) => {
	if (t === n) return !0;
	if (Object.keys(t).length !== Object.keys(n).length) return !1;
	for (let i of Object.keys(t)) {
		let a = t[i], o = n[i];
		if (r(a) && r(o)) {
			if (!e(a, o)) return !1;
		} else if (a !== o) return !1;
	}
	return !0;
}, n = (e, t) => {
	let n = {};
	for (let r of Object.keys(e)) t.includes(r) || (n[r] = e[r]);
	return n;
};
function r(e) {
	return Array.isArray(e);
}
//#endregion
export { t as equalFlatObjects, n as removeKeysFromObj };
